module.exports = __webpack_public_path__ + "img/IsSignatureRequested.3733e4f0.svg";